export const siteSettings = {
  name: "Real Edge Finance",
  link: "https://realedgefinance.net/",
  email: "support@realedgefinance.net/",
  appLink: "https://app.realedgefinance.net/",
};
